import React from 'react';

const ProblemSection = () => {
  return (
    <section className="problem-section section-container">
      <div className="section-header">
        <h2 className="section-title">El problema real</h2>
      </div>

      <div className="problem-content">
        <p className="problem-intro">
          El delantero falla y vuelve a intentarlo.<br />
          <span className="highlight">El arquero falla y cambia el resultado.</span>
        </p>

        <div className="problem-list">
          <h3>El arquero:</h3>
          <ul>
            <li>Vive la presión más alta del equipo</li>
            <li>Carga la responsabilidad total</li>
            <li>Es el menos comprendido tácticamente</li>
            <li>Es tratado como uno más por agencias generalistas</li>
          </ul>
        </div>

        <p className="problem-conclusion">
          El puesto más exigente del fútbol no puede tener representación estándar.
        </p>
      </div>

      <div className="problem-visual">
        <img 
          src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/t1r0s30i_IMG_9985.jpeg" 
          alt="Goalkeeper pressure"
          className="section-image"
        />
      </div>
    </section>
  );
};

export default ProblemSection;
